import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import QuickscanDetailModal from '../../QuickscanDetailModal';
import { useAdminContext } from '../../../contexts/AdminContext';

const QuickscanDetailWrapper = () => {
  const {
    handleDeleteAssessment,
    handleUpdateLeadStatus,
    selectedAssessment,
    setAssessments,
    setSelectedAssessment,
  } = useAdminContext();

  return (
    <>
    {/* Quickscan Detail Modal - Refactored Component */}
    <QuickscanDetailModal
      assessment={selectedAssessment}
      isOpen={!!selectedAssessment}
      onClose={() => setSelectedAssessment(null)}
      onUpdate={(updatedAssessment) => {
        setAssessments((prev) =>
          prev.map((a) => (a.id === updatedAssessment.id ? { ...a, ...updatedAssessment } : a))
        );
        setSelectedAssessment({ ...selectedAssessment, ...updatedAssessment });
      }}
      onDelete={(id) => {
        handleDeleteAssessment(id);
      }}
      onUpdateLeadStatus={handleUpdateLeadStatus}
    />
    </>
  );
};

export default QuickscanDetailWrapper;
